﻿/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["zh"] = {
    wikiLinkLabel:  "讨论"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/zh/timeline.js
// module id = 599
// module chunks = 3